'use client'
import type { ReactNode } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Skeleton({ className, rows = 1 }: { className?: string; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className={cx('animate-pulse rounded-xs bg-sunken', className || 'h-4 w-full', i > 0 && 'mt-2')}
        />
      ))}
    </>
  )
}
